import { gql } from '@apollo/client';

// #58 «Napisz do prowadzącego» — только Slack (решение владельца 07.10).
//
// Имя операции `StudentGroupTeacherContacts` намеренно отличается от поля
// бэкенда `myGroupTeacherContacts` (скилл graphql-codegen), как у
// `StudentGroupAttendance` / `myAttendance`.
//
// Поле только для LMS-токена с АКТИВНОЙ ролью Student: преподавателю сервер
// отвечает ошибкой прав, поэтому запрос уходит только из-под студента
// (гейт — в `useGroupTeacherContacts`). Пустой список — у группы нет
// включённого Slack или ни один преподаватель там не привязан: кнопки нет.
// Ссылки собирает сервер, клиент их не склеивает.
export const StudentGroupTeacherContactsQuery = gql`
  query StudentGroupTeacherContacts($groupId: ID!) {
    myGroupTeacherContacts(groupId: $groupId) {
      teacherId
      fullName
      photo
      slackAppUrl
      slackWebUrl
    }
  }
`;
